import Link from 'next/link'

type Props = {
  name: string
}

export const RecommendTagListItem = ({ name }: Props): JSX.Element => (
  <Link href={`/programs/${name}`} passHref>
    <button className="flex justify-center items-center px-[2.1vw] lg:px-[1.7vw] mx-[1.2vw] lg:mx-[0.6vw] mb-[2.5vw] lg:mb-[1.4vw] h-[5.2vw] lg:h-[2.4vw] bg-[#FFF2DD] rounded-[100px] lg:hover:opacity-70">
      <a className="text-[2.7vw] lg:text-[0.9vw] font-bold tracking-[0.1vw] lg:tracking-[0.1vw] text-[#2C2C2C]">
        {name}
      </a>
    </button>
  </Link>
)
